export const getAnswersForThisAssetId = (tableData, checkPeriodId) => {
    //console.log(`🥝 Getting asset ids from answers for checkPeriodId: ${checkPeriodId}`)

    const assetIds = {}

    if (tableData && tableData.ChecklistQuestions && tableData.ChecklistAnswers){
        Object.values(tableData.ChecklistAnswers).forEach((checklistAnswer) => {
            if (checklistAnswer.ChecklistPeriodId === checkPeriodId){
                const questionId = checklistAnswer.QuestionId
                const thisQuestion = tableData.ChecklistQuestions[questionId]
                if (thisQuestion && thisQuestion.AssetId){
                    assetIds[thisQuestion.AssetId] = {
                        pending: checklistAnswer.Pending,
                        answerId: checklistAnswer.Id,
                    }
                }
            }
        })
    }

    //console.log(`🍇 assetIds: ${JSON.stringify(assetIds)}`)
    return assetIds
}